import React from "react";
import { Button } from "@mui/material";
import {PTTranslate} from "./PTTranslate"
import { useLanguage } from "../../hooks";

export const PTButton = ({isHidden, ...props}) => {
  if(isHidden?.() ) return null
  return <PTButtonUI {...props} />
}

const PTButtonUI = ({
  type,
  color,
  startIcon,
  endIcon,
  variant = "outlined",
  title,
  onClick,
  sx,
  sxAdjust,
  ...props
}) => {
   const { currentLang } = useLanguage();
  const onClickBtn = (event) => {
    event.stopPropagation();
    if (type === "submit") {
      if (typeof props.handleSubmit != 'function')
        return
      props.handleSubmit();
    }
    if (onClick && typeof onClick === "function") onClick();
  }
  return (
    <Button
      variant={variant}
      onClick={onClickBtn}
      startIcon={currentLang === "ar" ? endIcon : startIcon}
      endIcon={currentLang === "ar" ? startIcon : endIcon}
      disableRipple={variant === "text"}
      sx={{
        fontSize: {md: "0.8rem", xs:  variant !== "text" && "0.5rem"},
        padding: variant !== "text" ? "2px 12px" : "0 0.3rem",
        border: variant !== "text" && "2px solid #25384a",
        background: variant === "text" && "transparent",
        fontWeight: "bold",
        textTransform: "none",
        textDecoration: variant === "text" && "underline",
        "&:hover": {
          border: variant !== "text" && "2px solid #25384a",
          background: variant === "text" && "transparent",
          textDecoration: variant === "text" && "underline",
          color: variant === "text" && "#25384acc",
        },
        "&:focus": {
          border: variant !== "text" && "2px solid #25384a",
          background: variant === "text" && "transparent",
          textDecoration: variant === "text" && "underline",
          color: variant === "text" && "#25384acc",
        },
        boxShadow: "none",
        ...sx,
        ...(currentLang === "ar" && {...sxAdjust}),
      }}
      {...props}
    >
      <PTTranslate tk={title} />
    </Button>
  );
};

export default PTButton;
